function ValidateEmail(inputText) {
    var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
    if (inputText.value.match(mailformat)) {
      return true;
    } else {
      return false;
    }
}

import { BuyButtons } from 'theme';

class ExtendedBuyButtons extends BuyButtons {
    constructor() {
        super();
        this.variantTitle = null;
        this.variantId = null;
        this.productId = null;
    }

    connectedCallback() {
        super.connectedCallback();
        document.addEventListener("variant:change", this.handleVariantChange);
        this.querySelector('.notify-back').addEventListener('click', this.handleClick);
        this.backInStock(null, false);
    }

    disconnectedCallback() {
        document.removeEventListener("variant:change", this.handleVariantChange);
        this.querySelector('.notify-back').removeEventListener('click', this.handleClick);
    }

    handleVariantChange = (event) => {
        this.backInStock(event.detail, false); 
    }

    handleClick = (event) => {
        this.backInStock(null, true);
    }

    updatePropertiesFromEvent(event) {
        this.variantTitle = event.variant.name;    
        this.variantId = event.variant.id;
        this.productId = event.product.id;
    }

    updatePropertiesFromJson(jsonData) {
        this.variantTitle = jsonData.selected_variant.name; 
        this.variantId = jsonData.selected_variant.id;
        this.productId = jsonData.product.id;
        this.variantTitle = jsonData.selected_variant.name; 
    }

    backInStock(event, submit) {
        let userEmail = this.querySelector('.BackInStock input');
        let label = this.querySelector('.BackInStock .floating-label');
        let jsonData;

        try {
            jsonData = JSON.parse(this.querySelector('[data-product-json]').innerHTML);
        } catch (error) {
            console.error('Error parsing JSON', error);
            return;
        }

        if (event) {
            console.log(event.variant.available);
            if(event.variant.available){
            this.querySelector('.BackInStock').classList.add('hidden');    
            }else{
            this.querySelector('.BackInStock').classList.remove('hidden');    
            } 
            this.updatePropertiesFromEvent(event);
        } else {
            this.updatePropertiesFromJson(jsonData);
        }

        if (submit) {
            if (ValidateEmail(userEmail)) {
                this.subscribeUser(userEmail, label);
            } else {
                this.updateUIForInvalidEmail(label);
            }
        }
    }

    subscribeUser(userEmail, label) {
        const options = {
            method: 'POST',
            headers: {
              accept: 'application/json',
              revision: '2024-07-15',
              'content-type': 'application/json'
            },
            body: JSON.stringify({
              data: {
                type: 'back-in-stock-subscription',
                attributes: {
                  profile: {
                    data: {
                      type: 'profile',
                      attributes: {
                        email: userEmail.value // Replace with dynamic email
                      }
                    }
                  },
                  channels: ['EMAIL'] // You can add 'SMS' if needed
                },
                relationships: {
                  variant: {
                    data: {
                      type: 'catalog-variant',
                      id: '$shopify:::$default:::' + this.variantId + '' // Replace with your Shopify variant ID
                    }
                  }
                }
              }
            })
          }; 
          fetch('https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id='+ window.themeVariables.settings.klaviyoId +'', options)
            .then(response => {
              response.text().then(text => console.log('Response text:', text));
              if (response.status === 202) {
                this.updateUIForSuccess(label, userEmail);
              }else {
                this.updateUIForInvalidEmail(label);
              }
            })
            .catch(err => {
              this.updateUIForNetworkError(label);
              console.log('Fetch error:', err);
  });
    }

    updateUIForSuccess(label, userEmail) {
        label.classList.add('subscribed');
        label.classList.remove('alert');
        userEmail.classList.add('subscribed');
        label.innerText = 'Subscribed: ' + this.variantTitle;
        this.querySelector('.notify-back').innerText = 'Subscribed';
    }

    updateUIForInvalidEmail(label) {
        label.classList.add('alert');
        label.classList.remove('subscribed');
        label.style.opacity = "1";
        label.innerText = 'Please enter a valid email';
    }

    updateUIForNetworkError(label) {
        label.classList.add('alert');
        label.innerText = 'Network error, try again later';
    }
}

if (!window.customElements.get("buy-buttons-extended")) {
    window.customElements.define("buy-buttons-extended", ExtendedBuyButtons);
}


document.addEventListener('variant:change', function(event) {
  const variant = event.detail.variant;
  if (!variant) return;

  const priceEl = document.getElementById('LoyaltyPrice');

  if (priceEl) {
    // Format price for display
    const formatted = Shopify.formatMoney 
      ? Shopify.formatMoney(variant.price, "{{ shop.money_format }}") 
      : (variant.price / 100).toFixed(2);

    priceEl.textContent = formatted;
  }
  // Update price element
  // Trigger LoyaltyLion live update
  if (window.LoyaltyLion?.renderComponents) {
    window.LoyaltyLion.renderComponents();
  }
});